import { FC } from 'react';
import Typography from '@components/common/typography';
import VerificationCode from '@components/verification_code';
import styles from './styles.module.scss';
import { hidePhoneNumber } from '@utils/index';
import { apiUserService } from '@api';
import { useApiMutation } from '@hooks/api/useApiMutation';
import { useTranslation } from 'react-i18next';
import { useLocales } from '@hooks/helpers/useLocales';
import { useApiQuery } from '@hooks/api/useApiQuery';
import { IModalComponentProps } from '@context/modal_context';

const VerificationPhoneModal: FC<
    IModalComponentProps<{
        phone_number: string;
        phone_code: string;
        phoneId: string;
        code: string;
        customCode?: boolean;
    }>
> = ({ modalData, changeModalData }) => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'verification_phone'
    });
    const { requestSuccessLocale, requestErrorLocale } = useLocales();

    const { handleRequest: handleResend } = useApiMutation({
        method: () => apiUserService.sendPhoneVerificationCode(modalData?.phoneId as string),
        onSuccess: () => {
            requestSuccessLocale('resent_phone_verification');
            changeModalData({ ...modalData, code: '' });
        },
        onError: requestErrorLocale
    });

    useApiQuery({
        method: () => apiUserService.sendPhoneVerificationCode(modalData?.phoneId as string),
        isInitialRequest: false,
        condition: !modalData?.customCode
    });

    return (
        <div className={styles.wrapper}>
            <Typography variant="h4" alignment="center" className={styles.title}>
                {t('title')}
            </Typography>
            <Typography variant="body3" alignment="center" className={styles.description}>
                {modalData?.phone_code ? (
                    <>
                        {t('to')}{' '}
                        <b>
                            {modalData?.phone_code &&
                                (modalData?.phone_code.includes('+')
                                    ? modalData?.phone_code
                                    : `+${modalData?.phone_code}`)}{' '}
                            {hidePhoneNumber(modalData?.phone_number)}
                        </b>
                    </>
                ) : (
                    t('to_primary')
                )}
            </Typography>
            <div className={styles.content}>
                {!modalData?.customCode && (
                    <div>
                        <Typography variant="body2" weight="medium" alignment="center">
                            {t('code_title')}
                        </Typography>
                        <button onClick={handleResend}>{t('resend')}</button>
                    </div>
                )}
                <VerificationCode
                    onChange={(value) => changeModalData({ ...modalData, code: value })}
                    value={modalData?.code}
                />
            </div>
        </div>
    );
};

export default VerificationPhoneModal;
